"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const contentConversions_1 = require("./contentConversions");
exports.contentFeedDetailData = graphql_tag_1.default `
  fragment contentFeedDetailData on ContentFeed {
    id
    name
    url
    responseType
    archived
    deleted
    headers
    cacheLength
    contentPushIsEnabled
    contentPushIndividualContentItems
    contentPushToken
    contentPushUrl
    resourceUrl
    resourceEndpoint
    useHeadersFromContentFeed {
      id
      name
    }
    contentSystem {
      id
      name
    }
    contentMapping {
      id
      name
      conversions {
        ...contentConversionDetailData
      }
      contentSystem {
        id
        name
      }
    }
  }
  ${contentConversions_1.contentConversionDetailData}
`;
exports.contentFeedListData = graphql_tag_1.default `
  fragment contentFeedListData on ContentFeed {
    id
    name
    url
    responseType
    archived
    deleted
    headers
    cacheLength
    contentPushIsEnabled
    contentPushIndividualContentItems
    contentPushToken
    contentPushUrl
    resourceUrl
    contentSystem {
      id
      name
    }
    contentMapping {
      id
      name
      conversions {
        ...contentConversionDetailData
      }
    }
  }
  ${contentConversions_1.contentConversionDetailData}
`;
//# sourceMappingURL=contentFeeds.js.map